/**
 * QR コード URL から hash パラメータを抽出する。
 * URL 形式: https://.../qr/?hash=<hash_value>
 * 取得できない場合は null を返す。
 */
export const extractQrHash = (qrText: string): string | null => {
  try {
    const url = new URL(qrText)
    const hash = url.searchParams.get('hash')
    return hash !== null && hash.length > 0 ? hash : null
  } catch {
    return null
  }
}

/**
 * QR ハッシュ文字列からスポット ID をパースする。
 * ハッシュ形式: `{hmac}-{spotId}` （例: `eb102ec9077bc24927a10f31f1d8bae1-9507`）
 * パースできない場合は null を返す。
 */
export const parseSpotIdFromHash = (hash: string): number | null => {
  const lastDash = hash.lastIndexOf('-')
  if (lastDash === -1) return null
  const candidate = hash.slice(lastDash + 1)
  // 数字のみで構成されていることを確認してからパース（"9507abc" 等の誤パース防止）
  if (!/^\d+$/.test(candidate)) return null
  const num = Number.parseInt(candidate, 10)
  return Number.isNaN(num) || num <= 0 ? null : num
}
